<template>
  <div class="cart-wrapper">
    <!-- 购物车有数据 -->
    <template v-if="cartInfo && cartInfo.list && cartInfo.list.length">
      <div class="cart-container">
        <h1 class="cart-header">购物车</h1>
        <div class="cart-checkout">
          <button class="checkout" :disabled="selectedQuantity === 0" @click="toCheckout">立即结算</button>
          <!-- 移动端全选栏 -->
          <div class="select-all-bar is-mobile" v-if="isH5" @click="selectAll">
            <span class="select-checkbox iconfont-ot-website"
              :class="{ 'icon-selected': isAllSelected, 'icon-unselected': !isAllSelected }">{{ isAllSelected ? '\ue6ef'
                : '\ue6ec' }}</span>
            <span class="select-all-label">全选</span>
            <!-- <span class="select-divider"></span>
            <span class="select-count">共 {{ selectedQuantity }} 件</span> -->
          </div>
        </div>
        <div class="cart-main">
          <!-- 购物车列表 -->
          <div class="cart-items">
            <div class="flex-row cart-thead">
              <div class="th item-image" @click="selectAll">
                <span class="select-checkbox iconfont-ot-website"
                  :class="{ 'icon-selected': isAllSelected, 'icon-unselected': !isAllSelected }">{{ isAllSelected ?
                    '\ue6ef' : '\ue6ec' }}</span>
                商品名称
              </div>
              <div class="item-other flex-row">
                <div class="th item-extra"></div>
                <div class="th item-price">价格</div>
                <div class="th item-count">数量</div>
                <div class="th item-total">总计</div>
              </div>
            </div>
            <div class="cart-item" v-for="(item, i) in cartInfo.list" :key="i">
              <div class="pre-tag-box" v-if="item.is_pre_sales === 1">
                <div class="item-tag">预售</div>
                <div class="pre-arrival-date" v-if="item.presale_date_content">
                  {{ item.presale_date_content }}
                </div>
              </div>
              <div class="flex-row cart-item-content" :class="{ 'is-pre': item.is_pre_sales === 1 }">
                <div class="td item-image">
                  <span class="select-checkbox iconfont-ot-website"
                    :class="{ 'icon-selected': Number(item.is_chose) === 1, 'icon-unselected': Number(item.is_chose) !== 1 }"
                    @click="toggleItem(item)">{{ Number(item.is_chose) === 1 ? '\ue6ef' : '\ue6ec' }}</span>
                  <!-- PC 端：直接 img，供 &>img 选择器匹配 -->
                  <img class="is-desktop" :src="item.images[0]" />
                  <!-- Mobile 端：wrapper 把 img + 编辑删除包成竖排 -->
                  <div class="item-image-body is-mobile">
                    <img :src="item.images[0]" />
                    <div class="item-action-m">
                      <button class="item-action item-edit" @click="editCartItem(item)">
                        编辑
                      </button>
                      <button class="item-action" @click="removeCartItem(item, { done: true })">
                        删除
                      </button>
                    </div>
                  </div>
                </div>
                <div class="item-other flex-row">
                  <div class="td item-extra">
                    <div class="item-sku-info">
                      <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                        <div v-for="(label, index) in item.custom_tags" :key="'custom' + index"
                          class="item-tag custom-tags is-mobile">
                          {{ label }}
                        </div>
                      </template>
                      <!-- 品牌名：全局商品卡统一在 name 上方，样式对齐 ViewItemInfo -->
                      <div class="item-detail-brand" v-if="item.brand">{{ item.brand.name }}</div>
                      <div class="item-name" @click="goDetail(item)">{{ item.name }}</div>
                      <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                        <div v-for="(label, index) in item.custom_tags" :key="'custom' + index"
                          class="item-tag custom-tags is-desktop">
                          {{ label }}
                        </div>
                      </template>
                      <div class="td item-price is-mobile">
                        <template v-if="isShowOriginalPrice(item) && isGwMdEnablePoint">
                          <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>
                          <p class="item-original_price">
                            ￥{{ (item.original_price || 0) | filterPrice }}
                          </p>
                        </template>
                        <template v-else>
                          <p><span class="rmb-symbol">￥</span>{{
                            (item.price || 0) | filterPrice
                          }}
                          </p>
                        </template>
                      </div>
                      <div class="item-attr is-desktop">
                        <span class="item-attr-name">颜色</span>:
                        <span class="item-attr-value">{{ item.color.name }}</span>
                      </div>
                      <div class="item-attr is-desktop">
                        <span class="item-attr-name">尺码</span>:
                        <span class="item-attr-value">{{ item.size.name }}</span>
                      </div>
                      <button class="item-action item-edit is-desktop" @click="editCartItem(item)">
                        编辑
                      </button>
                    </div>
                  </div>
                  <div class="td item-price is-desktop">

                    <template v-if="isShowOriginalPrice(item) && isGwMdEnablePoint">
                      <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>
                      <p class="item-original_price">
                        ￥{{ (item.original_price || 0) | filterPrice }}
                      </p>
                    </template>
                    <template v-else>
                      <p><span class="rmb-symbol">￥</span>{{
                        (item.price || 0) | filterPrice
                      }}
                      </p>
                    </template>
                  </div>
                  <div class="td item-color-size is-mobile">
                    <div class="item-attr">
                      <span class="item-attr-name">颜色</span>:
                      <span class="item-attr-value">{{ item.color.name }}</span>
                    </div>
                    <div class="item-attr">
                      <span class="item-attr-name">尺码</span>:
                      <span class="item-attr-value">{{ item.size.name }}</span>
                    </div>
                  </div>
                  <div class="td item-count">
                    <p class="item-label-mobile">
                      <span>数量</span>
                      <span v-if="isNumber(item.limit_qty)" class='limit-text-mobile'>同款限购{{ item.limit_qty }}件</span>
                    </p>
                    <template v-if="item.size.stock > 0">
                      <div class="select-style">
                        <select v-model="item.quantity" @change="setQuantity(item, $event)">
                          <option v-for="i in getItemCounterMax(item)" :key="`item_${item.id}-quantity_${i}`"
                            :value="i">
                            {{ i }}
                          </option>
                        </select>
                      </div>
                    </template>
                    <template v-else>
                      <div class="no-stock">暂无库存</div>
                    </template>
                    <p v-if="isNumber(item.limit_qty)" class='limit-text-desktop'>同款限购{{ item.limit_qty }}件</p>
                    <button class="item-action is-desktop" @click="removeCartItem(item, { done: true })">
                      删除
                    </button>
                  </div>
                  <div class="td item-total">
                    <span class="rmb-symbol">￥</span>{{ item.total }}
                  </div>
                </div>
              </div>
              <p class="markdown-tip" v-if="item.is_mark_down"><span
                  class="iconfont-ot-website">&#xe60f;</span><span>折扣商品不可与其他活动同时享受折扣</span></p>
            </div>
          </div>
          <!-- 购物车小计、合计等信息 -->
          <div class="cart-extra">
            <div class="cart-summary-header">订单总计</div>
            <div class="cart-subtotals">
              <div class="order-subtotal kv-line">
                <span>商品总额</span>
                <span><span class="rmb-symbol">￥</span>{{ cartInfo.amount }}</span>
              </div>
              <div class="order-shipping kv-line">
                <span>运费</span>
                <span><span class="rmb-symbol">￥</span>{{ cartInfo.shipping }}</span>
              </div>
            </div>
            <div class="cart-total kv-line">
              <span>总计</span>
              <span><span class="rmb-symbol">￥</span>{{ cartInfo.amount }}</span>
            </div>
            <button class="checkout" :disabled="selectedQuantity === 0" @click="toCheckout">立即结算</button>
            <button class="continue" @click="goShopping">继续购物</button>
          </div>
        </div>
      </div>
      <div class="browse-history">
        <RecentlyViewed />
      </div>
      <!-- 编辑购物车记录弹框 -->
      <div class="dialog view-item-dialog" v-if="editingItem && editingItem.id && editingItem.color">
        <div class="mask"></div>
        <div class="dialog-container">
          <div class="dialog-header">
            <div class="dialog-title">商品信息</div>
            <button type="button" class="dialog-close" @click="closeSKUDialog">
              <span class="close-icon"></span>
            </button>
          </div>
          <div class="dialog-body">
            <ViewItemInfo scope="cart" :id="editingItem.id" :color="editingItem.color" :size="editingItem.size"
              :count="editingItem.count" :styleNumber="editingItem.style_number" confirmText="更新购物车" @notify="showNotify"
              @confirm="confirm" />
          </div>
        </div>
      </div>
      <!-- 到货通知 -->
      <div class="dialog notify-dialog" v-if="notifyItem">
        <div class="mask"></div>
        <div class="dialog-container">
          <div class="dialog-header">
            <div class="dialog-title">到货通知</div>
            <button class="dialog-close" @click="hideNotifyDialog">
              <span class="close-icon"></span>
            </button>
          </div>
          <div class="dialog-body">
            <ItemNotify :source="notifyItem" @confirm="sendNotify" />
          </div>
        </div>
      </div>
      <!-- 登录弹窗 -->
      <div class="dialog dialog-login" v-if="showLogin">
        <div class="mask"></div>
        <div class="dialog-container">
          <div class="dialog-header">
            <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
          </div>
          <div class="dialog-body">
            <Login :returnUrl="returnUrl" />
          </div>
        </div>
      </div>
      <!-- 结算提醒弹窗（预售/现货需分开结算） -->
      <div class="dialog dialog-settlement" v-if="showSettlement">
        <div class="mask" @click="hideSettlementDialog"></div>
        <div class="dialog-container settlement-container">
          <div class="dialog-header">
            <div class="dialog-title">结算提醒</div>
            <button type="button" class="dialog-close" @click="hideSettlementDialog">
              <i class="iconfont-ot-website">&#xe6df;</i>
            </button>
          </div>
          <div class="dialog-body settlement-body">
            <p class="settlement-desc desc-desktop">预售与现货商品需分开结算，请点击下方完成支付</p>
            <p class="settlement-desc desc-mobile">预售与现货商品需分开结算，<br />请点击下方完成支付</p>
            <div class="settlement-btns">
              <button class="btn-standard" @click="handleSettlement('standard_settlement')">现货商品结算</button>
              <button class="btn-presale" @click="handleSettlement('presale_settlement')">预售商品结算</button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 购物车空状态 -->
    <template v-else>
      <div class="cart-empty">
        <h1 class="empty-hits">您的购物车为空</h1>
        <template v-if="isLogin">
          <div class="btns-group">
            <button class="continue-shopping" @click="goShopping">
              继续购物
            </button>
          </div>
        </template>
        <template v-else>
          <div class="cart-empty-hits">请登录账户查看你购物车</div>
          <div class="btns-group">
            <button class="user-login" @click="goLogin">登录账户</button>
            <button class="continue-shopping" @click="goShopping">
              继续购物
            </button>
          </div>
        </template>
        <Recommond />
      </div>
    </template>
  </div>
</template>

<script>
import Recommond from "@/components/Recommend.vue";
import RecentlyViewed from "@/components/RecentlyViewed.vue";
import ViewItemInfo from "@/components/ViewItemInfo.vue";
import ItemNotify from "@/components/ItemNotify.vue";
import Login from "@/components/Login.vue";
import api from "@/utils/api";
import utils from "@/utils";
import types from "@/store/types";
import { isNumber } from 'lodash'
export default {
  name: "CartList",
  components: { RecentlyViewed, Recommond, ViewItemInfo, ItemNotify, Login },
  data() {
    return {
      // 弹窗
      editingItem: null, // 编辑购物车记录 - 商品信息(id,color)
      notifyItem: null, // 到货通知 - 商品信息
      showLogin: false, // 登录弹窗
      returnUrl: "",
      showSettlement: false, // 结算提醒弹窗（预售/现货需分开结算）
    };
  },
  created() {
    // 每次进入购物车页面都刷新购物车数据
    this.$store.dispatch(types.GET_CART_INFO);
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    isNumber: isNumber,
    // 修改数量
    setQuantity(info, evt) {
      let dom = evt.target || evt.srcElement;
      this.updateItemOptions(
        {
          item: Number(info.id),
          product: Number(info.goodsId),
          super_attribute: {
            [info.color?.attribute_id]: info.color?.id,
            [info.size?.attribute_id]: info.size?.option_id,
          },
          qty: Number(dom.value),
        },
        () => {
          this.$message({ message: "更新成功" });
        }
      );
    },
    // 编辑购物车中的记录：显示商品SKU选择弹层
    editCartItem(info) {
      console.log(info, 'info');

      let { id, goodsId, color, quantity, size } = info;
      this.editingItem = {
        cartId: id,
        id: goodsId,
        color: color.id,
        // 用嵌套 size 对象的 id 回显选中尺码(对齐 mp sizeId = item.size.id), sku 字段与尺码 id 匹配不上
        size: size?.id,
        count: quantity,
        goodsId,
        // 详情接口 sku 参数使用
        style_number: info.style_number,
      };
    },
    // 显示到货通知弹窗
    showNotify(info) {
      if (!info || !info.id) return console.warn("缺少商品信息"), false;
      this.editingItem = null;
      this.notifyItem = info;
    },
    // 确认更新购物车（换规格/改数量统一走修改接口，对齐 mp updateItem）
    confirm(args) {
      let { info, color, size, quantity } = args;
      let oid = this.editingItem.cartId;
      this.updateItemOptions(
        {
          item: Number(oid),
          product: Number(info.id),
          super_attribute: {
            [color?.attribute_id]: color?.id,
            [size?.attribute_id]: size?.option_id,
          },
          qty: Number(quantity),
        },
        () => {
          this.$message({ message: "更新成功" });
          this.closeSKUDialog();
        }
      );
    },
    // 关闭商品SKU选择弹层
    closeSKUDialog() {
      this.editingItem = null;
    },
    // 删除购物车中的记录
    removeCartItem(info) {
      this.$confirm("确定要从购物车删除该商品吗？")
        .then(() => {
          this.delCart(info, { done: true });
        })
        .catch(() => { });
    },
    // 删除购物车中的记录-用户 DEL_CUSTOMER_CART / 游客 DEL_CART_GUEST
    delCart(info, options) {
      let { id } = info;
      const apiType = this.isLogin ? types.DEL_CUSTOMER_CART : types.DEL_CART_GUEST;
      api[apiType]({ item_ids: [String(id)] })
        .then((res) => {
          if (res?.code == 1) {
            this.$store.commit(types.GET_CART_INFO, res.data);
            if (options?.done) {
              this.$message({ message: "删除成功" });
            }
            typeof options?.callback == "function" && options.callback();
            //
            this.gaTrack4RemoveFromCart({
              id: info.style_number,
              name: info.name,
              price: info.price,
              quantity: info.quantity,
              variant: info.color?.name,
            });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 更新购物车商品-用户 UPDATE_CUSTOMER_ITEM_OPTIONS / 游客 UPDATE_ITEM_OPTIONS
    updateItemOptions(param, callback) {
      const apiType = this.isLogin ? types.UPDATE_CUSTOMER_ITEM_OPTIONS : types.UPDATE_ITEM_OPTIONS;
      api[apiType](param)
        .then((res) => {
          if (res?.code == 1) {
            this.$store.commit(types.GET_CART_INFO, res.data);
            typeof callback == "function" && callback();
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    gaTrack4RemoveFromCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "remove_from_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              price: Number(info.price),
              quantity: Number(info.quantity),
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
            },
          ],
        });
      }
    },
    // 关闭到货通知弹窗
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 结算：对齐 mp checkout.confirm 的 CART 分支 — while 循环校验，多 code 分支处理
    async toCheckout() {
      if (!this.isLogin) {
        this.showLoginDialog();
        return;
      }
      try {
        let settleType = "verify";
        let settleTipMessage = "";
        let verified = false;
        // 校验循环：处理多种 code 分支和选择后的二次校验
        while (!verified) {
          const verifyRes = await api[types.VERIFY_CART]({ type: settleType }).catch((e) => e);
          const code = Number(verifyRes?.code);

          // 1 - 全普通，正常通过
          if (code === 1) {
            verified = true;
          } else if (code === 3101) {
            // 3101 - 全预售 + 全无资格，轻提示后拦截
            this.$message.warning(verifyRes?.message || "您选中的预售商品暂无资格购买");
            return;
          } else if (code === 3102 || code === 3104) {
            // 3102 - 全预售 + 部分有资格，后端已自动取消无资格项
            // 3104 - 普通 + 预售全无资格，后端已自动取消所有预售项
            // 继续结算，message 带到结算页弹轻提示
            settleTipMessage = verifyRes?.message || "";
            verified = true;
          } else if (code === 3103) {
            // 3002 - website 后端：预售与现货混合需分开结算
            // 3103 - mp 后端：普通 + 预售有资格
            // 弹窗让用户选择结算类型后二次校验
            try {
              settleType = await new Promise((resolve, reject) => {
                this.settlementResolve = resolve;
                this.settlementReject = reject;
                this.showSettlement = true;
              });
            } catch (e) {
              return; // 用户关闭弹窗，终止结算
            }
            // continue 进入下一轮校验
          } else {
            // 未知 code，兜底直接走结算
            verified = true;
          }
        }
        // 获取结算页信息，缓存后跳转（settleTip 跟着 confirmRes 一起缓存，不污染 URL）
        const confirmRes = await api[types.CONFIRM]().catch((e) => e);
        if (!confirmRes || Number(confirmRes?.code) !== 1) {
          console.warn("CONFIRM failed", confirmRes);
          return;
        }
        const confirmCacheKey = await this.$store.dispatch("requestCache/setRequestCache", {
          value: { confirmRes, settleTip: settleTipMessage },
        });
        this.$router.push({ path: "/checkout", query: { confirmCacheKey } });
      } catch (err) {
        console.warn(err);
      }
    },
    // 弹窗按钮：resolve 结算类型，继续 toCheckout 中的流程
    handleSettlement(type) {
      this.showSettlement = false;
      const resolve = this.settlementResolve;
      this.settlementResolve = null;
      this.settlementReject = null;
      resolve?.(type);
    },
    // 关闭弹窗（X/遮罩）：reject 结束等待，避免结算按钮卡 loading
    hideSettlementDialog() {
      this.showSettlement = false;
      const reject = this.settlementReject;
      this.settlementResolve = null;
      this.settlementReject = null;
      reject?.(new Error("settle verify canceled"));
    },
    // 继续购物
    goShopping() {
      this.$router.push({ path: "/" });
    },
    // 显示登录弹窗：登录成功后停留当前购物车页，不跳结算页
    showLoginDialog() {
      this.returnUrl = encodeURIComponent(this.$route.fullPath);
      this.showLogin = true;
    },
    goLogin() {
      this.$router.push({
        name: "Login",
        query: {
          returnUrl: encodeURIComponent(this.$route.fullPath),
        },
      });
    },
    // 关闭登录弹窗
    hideLoginDialog() {
      this.returnUrl = "";
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
    getItemCounterMax(item) {
      const maxStock = 6; // SKU 最多购买六件
      const limitQty = isNumber(item.limit_qty) ? item.limit_qty : Infinity;
      return Math.max(item.quantity || 0, Math.min(maxStock, item.size.stock, limitQty,));
    },
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id || !item?.pdp_url) {
        return
      }
      if (Number(item.skc_status) === 0) {
        //skc下架
        return
      }
      this.$router.push({ path: this.getProductRoutePath(item) });
    },
    // 切换单个商品选中状态
    async toggleItem(item) {
      const list = this.cartInfo?.list || []
      // 当前所有选中的 id（排除当前项，若取消选中则不加入）
      const itemIds = list
        .filter(i => Number(i.is_chose) === 1 && String(i.id) !== String(item.id))
        .map(i => String(i.id))
      // 如果当前项原来是未选中，加入它
      if (Number(item.is_chose) !== 1) {
        itemIds.push(String(item.id))
      }
      await this.callChangeChose(itemIds)
    },
    // 全选/全不选
    async selectAll() {
      const allList = this.cartInfo?.list || []
      const itemIds = this.isAllSelected
        ? []
        : allList.map(i => String(i.id))
      await this.callChangeChose(itemIds)
    },
    // 调用勾选接口：登录走 changeChoseOfCustomerCart，游客走 changeChose，返回数据直接覆盖购物车
    async callChangeChose(itemIds) {
      try {
        const chooseApi = this.isLogin ? types.CHANGE_CHOOSE_OF_CUSTOMER_CART : types.CHANGE_CHOOSE;
        const res = await api[chooseApi]({ item_ids: itemIds })
        if (res?.code == 1 && res?.data) {
          this.$store.commit(types.GET_CART_INFO, res.data)
        }
      } catch (err) {
        console.warn('changeChose error', err)
      }
    },
  },
  // Login 组件无事件回调，登录成功以登录态变化感知并关闭弹框
  watch: {
    isLogin(val) {
      if (val && this.showLogin) {
        this.hideLoginDialog();
      }
    },
  },
  computed: {
    // 新客标签展示开关(页面级过滤已在 App.getUserState 处理, 这里直接读全局开关)
    calcIsShowCustomerTag() {
      return this.$store.state.isShowCustomerTag;
    },
    // 是否允许显示原价（受 gw_md_enable 配置控制）
    isGwMdEnablePoint() {
      return utils.isGwMdEnable(this.$store.state.commonConfig['gw_md_enable'], 'cart')
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    cartInfo() {
      return this.$store.state.cartInfo;
    },
    isH5() {
      return window.innerWidth <= 768;
    },
    // 是否全部选中（参考 mp cart store）
    isAllSelected() {
      const list = this.cartInfo?.list || []
      return list.length > 0 && list.every(item => Number(item.is_chose) === 1)
    },
    // 选中的商品列表
    selectedCartItems() {
      return (this.cartInfo?.list || []).filter(item => Number(item.is_chose) === 1)
    },
    // 选中商品数量
    selectedQuantity() {
      return this.selectedCartItems.reduce((sum, item) => sum + (item.quantity || 0), 0)
    },
    // 选中商品总金额
    selectedTotal() {
      return this.selectedCartItems.reduce((sum, item) => sum + (item.total || 0), 0)
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-wrapper {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 0 10px;
  margin: auto;
  text-align: left;

  // 复选框基础样式（PC & Mobile 共用）
  .select-checkbox {
    font-family: 'iconfont-ot-website';
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;
    display: inline-block;
    text-align: center;

    &.icon-selected {
      color: #7f0019;
    }

    &.icon-unselected {
      color: #b4b5b4;
    }
  }

  .cart-container {
    margin: 30px 0 0 0;
    padding: 0 0 20px;
    position: relative;

    .cart-header {
      font-weight: 400;
      font-size: calc(1.5rem * 1.6);
      color: #333;
      margin: 20px 0 25px;
    }

    .cart-error {
      background-color: #fff;
      border: 1px solid #bd0025;
      border-radius: 0.5em;
      margin: 0.5em 0;
      padding: 0.8em;
    }

    .cart-checkout {
      margin-top: 0.5rem;
      padding-bottom: 1em;
      position: relative;

      .checkout {
        display: none;
        box-sizing: border-box;
        width: 100%;
        height: 45px;
        padding: 0 30px;
        font-weight: 400;
        font-size: calc(1.125rem * 1.6);
        line-height: 38px;
        color: #fff;
        cursor: pointer;
        background-color: #7f0019;
        border: 1px solid #7f0019;
        border-radius: 2px;

        &:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      }
    }

    .cart-main {
      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .cart-items {
        width: 65%;
        float: left;

        .flex-row {
          display: flex;
        }

        .cart-thead {
          .th {
            font-weight: 400;
            font-size: calc(0.875rem * 1.6);
            line-height: calc(1.3125rem * 1.6);
            letter-spacing: 0.025em;
            text-transform: uppercase;
            padding: 15px 0;
            background: none;
            border-bottom: 1px solid #b4b5b4;
            border-top: 1px solid #b4b5b4;
            color: #000;
          }

          .item-image {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            width: 150px;
          }
        }

        .cart-item {
          border-bottom: 1px solid #b4b5b4;

          .pre-tag-box {
            display: flex;
            align-items: center;
            flex-direction: row;
            gap: 8px;
            font-size: 10px;
            padding-top: 20px;
            color: #212322;

            .item-tag {
              width: max-content;
              color: #212322;
              font-size: 10px;
              font-style: normal;
              font-weight: 400;
              /* 150% */
              padding: 2px 5px;
              border: 1px solid #212322;
            }
            .pre-arrival-date{
              font-size: 10px;
            }
          }


          .markdown-tip {
            display: flex;
            align-items: center;
            color: #212322;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 12px;

            .iconfont-ot-website {
              margin-right: 2px;
            }
          }
        }

        .cart-item-content {

          .td {
            box-sizing: border-box;
            padding: calc(1.25rem * 1.6) 0;

            .no-stock {
              color: #BABEC2;
            }

            .item-action {
              box-sizing: border-box;
              display: inline-block;
              border-radius: 2px;
              cursor: pointer;
              font-weight: 400;
              font-size: calc(0.75rem * 1.6);
              line-height: 1.5em;
              color: #333;
              text-align: center;
              text-decoration: underline;
              background-color: transparent;
              border-width: 0;
              padding: 0;
              margin-top: calc(0.5rem * 1.6);
            }
          }

          &.is-pre {
            .item-image {
              padding-top: 12px;
            }

            .td {
              padding-top: 12px;
            }
          }
        }

        .item-other {
          flex: 1;
        }

        .item-image {
          // width: 18%;
          text-align: left;
          display: flex;
          align-items: flex-start;
          gap: 8px;
          width: 146px;

          &>img {
            width: 122px;
            object-fit: cover;
            flex-shrink: 0;
          }
        }

        .item-extra {
          width: 51%;
          text-align: left;

          .item-sku-info {
            line-height: 1.5em;
            padding-right: 10px;

            .item-detail-brand {
              color: #BABEC2;
              font-weight: 700;
              font-size: 15px;
              margin-bottom: 4px;
            }

            .item-name {
              font-weight: 400;
              font-size: calc(1rem * 1.6);
              line-height: calc(1.375rem * 1.6);
              color: #000;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            .item-tag {
              font-size: 10px;
              border: 1px solid #212322;
              padding: 0px 5px;
              margin: 4px 0;
              line-height: 18px;
              color: #212322;
              width: fit-content;
            }

            .item-attr {
              .item-attr-name {
                font-weight: 700;
                font-size: calc(0.875rem * 1.6);
                color: #000;
                line-height: 1em;
              }

              .item-attr-value {
                font-weight: 400;
                font-size: calc(0.875rem * 1.6);
                color: #000;
                line-height: 1em;
              }
            }

            .item-edit {
              margin-top: 0;
            }
          }

          &.td {
            padding-left: 20px;
          }
        }

        .item-price {
          width: 17%;
          text-align: left;
          font-weight: 400;
          font-size: calc(1rem * 1.6);
          color: #000;

          &.is-mobile {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
          }

          .item-original_price {
            color: #999;
            line-height: 20px;
            text-decoration: line-through;
          }
        }

        .item-count {
          width: 14.6%;
          text-align: left;

          .item-label-mobile {
            display: none;
            font-weight: 700;
            font-size: calc(0.75rem * 1.6);
            margin-bottom: 5px;
          }

          .limit-text-desktop {
            color: #BABEC2;
            margin-top: 8px;
            font-size: calc(0.75rem * 1.6);
            font-weight: 400;
            line-height: calc(1.125rem * 1.6);
          }

          .limit-text-mobile {
            color: #BABEC2;
            margin-left: 8px;
          }

          .select-style {
            box-sizing: border-box;
            max-width: 72px;
            border: 1px solid #b4b5b4;
            border-radius: 2px;
            overflow: hidden;
            display: block;
            padding-right: 31px;
            background: #fff url(../assets/imgs/icons/onitsukatiger-drop-down-arrow.svg) no-repeat scroll;
            background-position: right 10px center;

            select {
              background: transparent;
              border: none;
              padding: 2px 0 2px 10px;
              height: 38px;
              width: calc(100% + 31px);
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
            }

            select::-ms-expand {
              display: none;
            }
          }
        }

        .item-total {
          width: 14.6%;
          text-align: right;
          font-weight: 700;
          font-size: calc(0.875rem * 1.6);
          color: #000;
        }
      }

      .cart-extra {
        width: 27%;
        padding: 0 10px 10px;
        border: 1px solid #b4b5b4;
        background: #efefef;
        float: right;

        .cart-summary-header {
          font-weight: 700;
          font-size: calc(0.875rem * 1.6);
          border-bottom: 1px solid #b4b5b4;
          color: #000;
          // margin-bottom: 18px;
          padding: 17px 0 15px;
          text-transform: uppercase;
        }

        .cart-selected-info {
          background: #f9f9f9;
          border: 1px solid #d4d4d4;
          border-radius: 4px;
          margin-bottom: 10px;
          padding: 8px 12px;
          font-weight: 700;
          color: #7f0019;

          span:last-child {
            font-weight: 700;
          }
        }

        .kv-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          padding: 5px 0;
          color: #000;
        }

        .cart-subtotals {
          padding: 10px 0;
        }

        .cart-total {
          border-bottom: 1px solid #b4b5b4;
          border-top: 1px solid #b4b5b4;
          font-size: calc(1rem * 1.6);
          font-weight: 400;
          padding: 15px 0;
          margin: 0;
          color: #000;
        }

        .checkout {
          font-weight: 400;
          font-size: calc(1.125rem * 1.6);
          width: 100%;
          height: 45px;
          color: #fff;
          background-color: #7f0019;
          border-color: #7f0019;
          border-radius: 2px;
          line-height: 38px;
          padding: 0 30px;
          margin-top: 20px;

          &:disabled {
            cursor: not-allowed;
            opacity: 0.6;
          }
        }

        .continue {
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          line-height: 3.25em;
          width: 100%;
          margin-right: 1em;
          text-decoration: underline;
          color: #000;
          margin: 0;
          background-color: transparent;
          border-width: 0;
          padding: 0;
          cursor: pointer;
          display: inline-block;
          box-sizing: border-box;
        }
      }
    }
  }

  .browse-history {
    padding-bottom: 45px;
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
      z-index: 1010;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-title {
          border-bottom: 1px solid #b4b5b4;
          font-weight: 400;
          font-size: calc(1.375rem * 1.6);
          color: #000;
          text-transform: uppercase;
          padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
          margin: 0 calc(1.25rem * 1.6);
          width: calc(100% - 40px);
          box-sizing: border-box;
        }

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        display: flex;
        box-sizing: border-box;
      }
    }

    &.view-item-dialog {
      .dialog-container {
        width: 920px;
        border: 1px solid #ddd;
        background: #efefef;

        .dialog-header {
          .dialog-title {
            display: none;
          }
        }

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.dialog-login {
      .dialog-container {
        width: 490px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {

          // padding: 0 45px;
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              .others-way {
                .iconfont {
                  text-align: center;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }

  }

  .dialog-settlement {
    .dialog-container.settlement-container {
      width: 600px;
      height: auto;
      min-height: 0;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-title {
          border-bottom: none;
          font-weight: 400;
          font-size: 18px;
          color: #212322;
          text-transform: none;
          padding: 40px 0 0;
          box-sizing: border-box;
          text-align: center;
          border-bottom-color: #e5e5e5;
        }

        .dialog-close {
          position: absolute;
          top: 20px;
          right: 20px;
          padding: 0;
          border: none;
          margin: 0;
          background-color: transparent;
          cursor: pointer;

          .iconfont-ot-website {
            font-size: 24px;
          }
        }
      }

      .dialog-body.settlement-body {
        flex-direction: column;
        padding: 24px 40px 40px;
        gap: 32px;

        .settlement-desc {
          font-size: 14px;
          text-align: center;
          color: #666;
          line-height: 1.7;
          margin: 0;

          &.desc-mobile {
            display: none;
          }
        }

        .settlement-btns {
          display: flex;
          gap: 16px;
          align-content: center;
          justify-content: center;

          .btn-standard,
          .btn-presale {
            // flex: 1;
            padding: 12px 58px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0.5px;
            border: none;
            cursor: pointer;
            transition: opacity 0.2s;
          }

          .btn-standard {
            background: #fff;
            color: #7f0019;
            border: 1px solid #7f0019;
          }

          .btn-presale {
            background: #7f0019;
            color: #fff;
            border: 1px solid #7f0019;
          }
        }
      }
    }
  }

  .cart-empty {
    padding: 30px 0;
    text-align: center;

    .empty-hits {
      font-size: calc(1.5rem * 1.6);
      font-weight: 400;
      color: #000;
      text-align: center;
      text-transform: none;
      line-height: calc(2.5rem * 1.6);
      margin: 0.67em 0;
    }

    .cart-empty-hits {
      width: 60vw;
      margin: 0 auto 0.625rem;
    }

    .btns-group {
      padding: 0.3125rem;

      .user-login {
        cursor: pointer;
        display: inline-block;
        width: calc(20.3125rem * 1.6);
        line-height: calc(1.625rem * 1.6);
        padding: 5px;
        margin: calc(1.3125rem * 1.6) 0;
        margin-right: 10px;
        font-weight: 400;
        font-size: calc(0.875rem * 1.6);
        letter-spacing: normal;
        border-radius: 2px;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        transition: all 0.3s ease;
        color: #fff;
        background-color: #000000;
        border: 1px solid #000000;
      }

      .continue-shopping {
        cursor: pointer;
        display: inline-block;
        box-sizing: border-box;
        width: calc(20.3125rem * 1.6);
        line-height: calc(1.625rem * 1.6);
        padding: 5px;
        margin: calc(1.3125rem * 1.6) 0;
        font-weight: 400;
        font-size: calc(0.875rem * 1.6);
        letter-spacing: normal;
        border-radius: 2px;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        transition: all 0.3s ease;
        color: #fff;
        background-color: #7f0019;
        border: 1px solid #7f0019;
      }
    }

    & ::v-deep .recommend-container {
      margin-top: calc(1.5625rem * 1.6);
      padding: 10px 30px 30px 30px;
      background-color: #ededed;
    }
  }
}

@media only screen and (max-width: 768px) {
  .cart-wrapper {
    .cart-container {
      .cart-main {
        .cart-items {
          width: 55%;

          .cart-thead {
            display: none;
          }

          .cart-item-content {
            // align-items: center;
            justify-content: space-between;

            &.is-pre {
              margin-top: 12px;
            }

            .item-image {
              width: 133px;
              height: auto;
            }

            .item-other {
              flex-direction: column;

              .item-extra {
                width: 100%;
                padding: 10px 0 10px 25px;
              }

              .item-price {
                width: 100%;
                padding: 0 0 10px 25px;
              }

              .item-color-size {
                display: flex;
                row-gap: 10px;
                column-gap: 20px;
                flex-direction: row;
                flex-wrap: wrap;
              }

              .item-count {
                width: 100%;
                padding: 0 0 10px 25px;
              }

              .item-total {
                width: 100%;
                padding: 0 0 10px 25px;
                text-align: left;
              }
            }
          }
        }

        .cart-extra {
          width: 36%;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .is-desktop {
    display: none !important;
  }

  .cart-wrapper {
    .cart-container {
      .cart-checkout {
        padding-bottom: 0;

        .checkout {
          display: block;
        }

        .select-all-bar {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid #b4b5b4;
          font-size: 12px;

          .select-checkbox {
            margin-right: 8px;
            font-size: 12px;
          }

          .select-all-label {
            color: #333;
          }

          .select-divider {
            width: 1px;
            height: 12px;
            background: #b4b5b4;
            margin: 0 8px;
          }

          .select-count {
            color: #333;
          }
        }
      }

      .cart-main {
        .cart-items {
          width: 100%;

          .cart-thead {
            display: none;
          }

          .cart-item {

            .pre-tag-box {
              padding-top: 16px;

              .item-tag {}
            }

            .markdown-tip {
              font-size: 12px;
              line-height: 18px;
              margin-bottom: 10px;

              .iconfont-ot-website {
                font-size: 12px;
              }
            }
          }

          .cart-item-content {
            margin-bottom: 20px;
            margin-top: 20px;

            .item-image {
              display: flex;
              flex-direction: row;
              align-items: flex-end;
              gap: 8px;

              // 复选框相对图片列垂直居中
              .select-checkbox {
                font-size: 12px;
                margin-bottom: 80px;
              }

              .item-image-body {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 100%;
                justify-content: flex-end;

                &>img {
                  width: 100%;
                }

                .item-action-m {
                  display: flex !important;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                  gap: 30px;
                  width: 100%;
                  margin-top: 8px;
                }
              }
            }

            .td {
              padding: 0 !important;
            }

            .item-other {
              flex-direction: column;
              gap: 10px;
              margin-left: 20px;

              .item-detail-brand {
                color: #BABEC2;
                font-weight: 700;
                font-size: 10px;
                margin-bottom: 2px;
              }

              .item-name {
                margin-bottom: 8px;
              }


              .item-extra {
                width: 100%;
              }

              // 单价（.item-extra 内）：黑色常规字号
              .item-extra .item-price {
                width: 100%;
                padding-left: 25px;
                padding-top: 0;
                color: #000;
                font-size: 15px;
              }

              // 颜色/尺码块（.item-other 直接子级）：同行排布
              &>.item-price {
                display: flex;
                align-items: center;
                gap: 24px;
                width: 100%;
                padding-left: 25px;
                padding-top: 0;
                color: #000;
                font-size: 13px;

                .item-attr-name {
                  font-weight: 400;
                }
              }

              // 下部（数量+合计）贴底：与图片列底部对齐
              .item-count {
                width: 100%;
                padding-left: 25px;
                padding-top: 0;
                margin-top: auto;

                .item-label-mobile {
                  display: block;
                }

                .limit-text-desktop {
                  display: none;
                }

                .select-style {
                  max-width: 96px;
                }
              }

              .item-total {
                width: 100%;
                padding-left: 25px;
                padding-top: 0;
                text-align: left;
                font-size: 16px;
              }


            }
          }
        }


        .cart-extra {
          width: 100%;
          box-sizing: border-box;
          margin-top: 20px;

        }
      }
    }

    .dialog {
      &.view-item-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
        }
      }

      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #fff;
        }
      }

      // 结算提醒弹窗（移动端）
      &.dialog-settlement {
        .dialog-container.settlement-container {
          width: 88%;

          .dialog-header {
            .dialog-title {
              font-size: 18px;
              text-align: center;
            }

            .dialog-close {
              top: 10px;
              right: 10px;
            }
          }

          .dialog-body.settlement-body {
            padding: 16px 24px 24px;
            gap: 16px;

            .settlement-desc {
              font-size: 13px;
              white-space: pre-line;

              &.desc-desktop {
                display: none;
              }

              &.desc-mobile {
                display: block;
              }
            }

            .settlement-btns {

              .btn-standard,
              .btn-presale {
                flex: 1;
                padding: 12px 26px;
              }
            }
          }
        }
      }
    }

    .cart-empty {
      .btns-group {
        flex-direction: column;

        .user-login,
        .continue-shopping {
          width: 100%;
          margin: calc(0.3125rem * 1.6) 0;
        }
      }

      & ::v-deep .recommend-container {
        padding: 0 0 30px 0;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .cart-wrapper {
    .dialog {
      &.view-item-dialog {
        .dialog-container {
          top: 0px;
          width: 100%;
          max-width: 100%;
          background: #fff;
          border-radius: 0;

          .dialog-header {
            .dialog-title {
              display: block;
            }

            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.notify-dialog {
        .dialog-container {
          top: 0px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.dialog-login {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #fff;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body {
            padding: 10px 0;

            & ::v-deep .login-component {

              .el-form {
                width: calc(100% - 40px);

                .input-item {
                  .el-form-item {
                    .verify-input {
                      min-width: 100px;
                    }

                    &.item-right {
                      width: 135px;
                      flex-grow: unset;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
@media screen and (min-width: 768px) {
  .cart-wrapper .dialog.view-item-dialog .dialog-container {
    top: max(50%, 370px);
  }

  .cart-wrapper .dialog.notify-dialog .dialog-container {
    top: max(50%, 355px);
  }

  /* .is-desktop  { 
    display: block !important;
  } */
  .is-mobile {
    display: none !important;
  }
}
</style>
